function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 16.5H8v-2.4h2v2.4zm0 1.2H8v2.4h2v-2.4zm6-3.6h-2v2.4h2v-2.4zm0 3.6h-2v2.4h2v-2.4zm-3-3.6h-2v2.4h2v-2.4zm0 3.6h-2v2.4h2v-2.4zm6-3.6h-2v2.4h2v-2.4zm0 3.6h-2v2.4h2v-2.4zm3-3.6h-2v2.4h2v-2.4zm-2 6h2v-2.4h-2v2.4zm-10 1.2H8v2.4h2v-2.4zm6 0h-2v2.4h2v-2.4zm-3 0h-2v2.4h2v-2.4zm6 0h-2v2.4h2v-2.4zm1 2.5h2v-2.4h-2v2.4zm9.1-16.7v19.2c0 1.5-1.2 2.7-2.7 2.7H3.6C2.1 29 .9 27.8.9 26.3V7.1c0-1.5 1.2-2.7 2.7-2.7h4.3V1.9c0-.5.4-.9.9-.9s.9.4.9.9v2.6h10.4V1.9c0-.5.4-.9.9-.9s.9.4.9.9v2.6h4.3c1.7-.1 2.9 1.1 2.9 2.6zm-1.9 3.6H2.8v15.7c0 .4.4.8.8.8h22.8c.4 0 .8-.4.8-.8V10.7zm0-3.6c0-.4-.4-.8-.8-.8H3.6c-.4 0-.8.4-.8.8v1.7h24.4V7.1z"
})));